module.exports = __webpack_public_path__ + "static/media/leonie.0e81f58c.jpg";